import initVueApp from "@/core.js";
const component = require(`./../views/Sus.vue`).default;
initVueApp(component);
